// The config stores a raw video URL. When it's a Mux URL we pull the playback
// ID out so the enroll flow can render the Mux player (and derive a poster);
// any other URL falls back to a plain <video>.

const MUX_URL = /(?:player|stream|image)\.mux\.com\/([A-Za-z0-9]+)/i;

export function isMuxUrl(url: string): boolean {
  return MUX_URL.test(url);
}

/** Playback ID from a player/stream/image Mux URL, or null if it isn't one. */
export function parseMuxPlaybackId(url: string): string | null {
  return url.match(MUX_URL)?.[1] ?? null;
}

/** Mux's auto-generated poster frame for a playback ID. */
export function muxPosterUrl(playbackId: string): string {
  return `https://image.mux.com/${playbackId}/thumbnail.jpg`;
}
